import React from 'react';

import styles from './Stat.module.scss';

interface StatProps {
    label: string;
    value: string;
}

const Stat: React.FC<StatProps> = ({ label, value }) => {
    return (
        <div className={styles.stat}>
            <p className={styles.label}>{label}</p>
            <p className={styles.value}>{value}</p>
        </div>
    );
};

export default Stat;
